// extracted by mini-css-extract-plugin
export var container = "_g7-1";
export var cornerButtonContainer = "_g7-6";
export var disabled = "_g7-2";
export var dragActive = "_g7-3";
export var fileContainer = "_g7-5";
export var hiddenInput = "_g7-4";
export var widthContainer = "_g7-0";